import(/* webpackMode: "eager" */ "/home/runner/_work/lt-telia-web-apps/lt-telia-web-apps/apps/PublicWeb/app/global-error.tsx");
